import { Spacing } from '@hg/stylizator/utils'
import * as React from 'react'

import { Animate, BottomContainer, HeaderPlaceholder, TopContainer, useHelloBar } from './common'

import ClientOnly from 'app/components/ClientOnly'
import HelloBarBlock from 'app/components/CustomBlocks/component/HelloBarBlock'
import useHasMounted from 'app/hooks/use-has-mounted'

const HoneygainSdkTopMenu = React.lazy(() => import('app/components/HoneygainSdkTopMenu'))
const HoneygainSdkFooter = React.lazy(() => import('app/components/HoneygainSdkFooter'))

interface Props {
  withPadding?: boolean
}

const HoneygainSdkLayout: React.FC<React.PropsWithChildren<Props>> = ({ children, withPadding }) => {
  const { showHelloBar, helloBarBlockData } = useHelloBar('honeygain-components/sdk-hello-bar')
  const hasMounted = useHasMounted()
  return (
    <>
      {hasMounted ? (
        <TopContainer>
          {showHelloBar && (
            <Animate $height="64px" className="hello-bar-container">
              <HelloBarBlock {...(helloBarBlockData as any)} />
            </Animate>
          )}

          <HoneygainSdkTopMenu />
        </TopContainer>
      ) : (
        <HeaderPlaceholder />
      )}
      {withPadding && <Spacing top={8} />}
      {children}
      <HoneygainSdkFooter />
      <ClientOnly>
        <BottomContainer>
          {showHelloBar && (
            <Animate $height="200px">
              <HelloBarBlock {...(helloBarBlockData as any)} />
            </Animate>
          )}
        </BottomContainer>
      </ClientOnly>
    </>
  )
}

export default HoneygainSdkLayout
